import axios from "axios";

export const TOKEN_KEY = "tz_token";

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/login") && !url.includes("/auth/verify-2fa")) {
      localStorage.removeItem(TOKEN_KEY);
      const loc = window.location;
      if (!loc.pathname.startsWith("/admin/login")) {
        loc.assign("/admin/login?expired=1");
      }
    }
    return Promise.reject(err);
  }
);

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function formatApiError(detail, fallback = "Something went wrong.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function readError(err, fallback = "Something went wrong.") {
  return formatApiError(err?.response?.data?.detail, err?.message || fallback);
}

export default api;
